import { render, staticRenderFns } from "./ConversionWhats.vue?vue&type=template&id=47bb6131&scoped=true&"
import script from "./ConversionWhats.vue?vue&type=script&lang=js&"
export * from "./ConversionWhats.vue?vue&type=script&lang=js&"
import style0 from "./ConversionWhats.vue?vue&type=style&index=0&id=47bb6131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb6131",
  null
  
)

export default component.exports